<template>
  <div class="home-stage">
    <div class="row">
      <div class="stage-title">Panel główny</div>
      <hr/>
<!--      <div class="card home-card version-info">-->
<!--        <div class="card-header home-card-header">-->
<!--          Wersja 1.01.5 BETA (12.03.2023)-->
<!--        </div>-->
<!--        <div class="card-body">-->
<!--          <h5 class="card-title">Zmiany w ostatniej wersji</h5>-->
<!--          <p class="card-text">-->
<!--            - Uruchomiono scentralizowaną werscje aplikacji PakietyMP-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
    </div>

  </div>


  <div class="container-fluid home-stage">
    <!-- Page Heading -->

    <!-- Content Row -->
    <div class="row">
      <!-- Area Chart -->
      <div>
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div
              class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
          >
            <h6 class="m-0 font-weight-bold text-primary">
             Aplikacja SimplePharm
            </h6>
            <div class="dropdown no-arrow">

            </div>
          </div>
          <!-- Card Body -->
          <div class="card-body">
            <div class="mt-3">
            <div>Aby rozpocząć pracę wybierz jeden z modułów dostepny w Menu powyżej.</div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>


</template>

<script>

import {tableData} from "@/views/DrugstoreCommonManager/data/exampleTable";
import {formData} from "@/views/DrugstoreCommonManager/data/exampleForm";
import {chartData} from "@/views/DrugstoreCommonManager/data/exampleChart";
import {exampleTasks} from "@/views/DrugstoreCommonManager/data/exampleTaskList";
import {calendarEvents} from "@/views/DrugstoreCommonManager/data/exampleCalendar";
import {emailData} from "@/views/DrugstoreCommonManager/data/exampleEmailInbox";
import {log} from "@/state/pinia/log";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";




export default {
  name: "HomeStart",
  components: {
  },
  data() {
    return {
      modalDisplayed: false,
      formRows: formData,
      exampleTable: tableData,
      exampleChartData: chartData,
      calendarEvents: calendarEvents,
      calendarOptions: {
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
        },
        plugins: [
        ],
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        initialEvents: calendarEvents,
        editable: true,
        droppable: true,
        eventResizableFromStart: true,
        dateClick: this.dateClicked,
        eventClick: this.editEvent,
        eventsSet: this.handleEvents,
        weekends: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
      },
      tasks: exampleTasks,
      inprogressTasks: "",
      upcomingTasks: "",
      completedTasks: "",
      title: "Task List",
      items: [
        {
          text: "Tasks",
          href: "/",
        },
        {
          text: "Task List",
          active: true,
        },
      ],
      taskList: {
        name: "",
      },
      myFiles: [],
      selected: "",
      selected2: "",
      submitted: false,
      showModal: false,

      allProfitChartData: {
        labels: [
          "2022-07",
          "2022-08",
          "2022-09",
          "2022-10",
          "2022-11",
          "2022-12",
          "2023-01",
          "2023-02",
        ],
        datasets: [
          {
            label: "Zysk (wszyscy)",
            data: [
              42555.14, 41764.82, 35584.59, 35417.93, 37993.65, 38985.99,
              44880.02, 37967.59,
            ],
            fill: true,
            backgroundColor: "rgba(28,200,138,0.2)",
            borderColor: "rgb(33,236,160)",
            tension: 0.1,
          },
        ],
      },
      emailData: emailData,
      paginatedEmailData: emailData,
    };
  },
  computed: {
        simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

    handleSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      } else {
        this.tasks.push({
          index: this.tasks.length + 1,
          taskType: this.selected,
          name: this.taskList.name,
          images: this.myFiles,
          status: this.selected2,
          checked: false,
        });
        this.isMountData();
        this.showModal = false;
        this.taskList = {};
        this.selected = "";
        this.selected2 = "";
        this.myFiles = [];
      }
      this.submitted = false;
    },

    isMountData() {
      this.tasks = exampleTasks;
      this.inprogressTasks = exampleTasks.filter((t) => t.taskType === "inprogress");
      this.upcomingTasks = exampleTasks.filter((t) => t.taskType === "upcoming");
      this.completedTasks = exampleTasks.filter((t) => t.taskType === "completed");
    },

    onFileChange(event) {
      for (var i = 0; i < event.target.files.length; i++) {
        this.myFiles.push(
            require("@/assets/images/users/" + event.target.files[i].name)
        );
      }
    },

    closeModal() {
      this.modalDisplayed = false;
    },
    sendForm(form) {
      log.log(form);
    },
    runAction(action) {
      log.log(action);
    },
    sort(sortKey) {
      log.log(sortKey);
    },
  },
  watch: {},
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>

<style scoped>
.home-stage {
  margin-left: 16px;
  margin-right: 16px
}

.version-info {
  margin-bottom: 5px;
}

.home-card {
  -webkit-box-shadow: 0px 3px 7px -5px #606060;
  box-shadow: 0px 3px 7px -5px #606060;
}

.home-card-header {
  color: #fff;
  background: #65c6c6;
}
</style>
